import { Zap } from 'lucide-react'
import { useAIRateLimit } from '../hooks'

export function RateLimitBadge() {
  const { data, isLoading } = useAIRateLimit()

  if (isLoading || !data) {
    return null
  }

  const percentage = (data.remaining / data.dailyLimit) * 100
  const isLow = percentage <= 20
  const isOut = data.remaining === 0

  return (
    <div
      className={`flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm ${
        isOut
          ? 'bg-red-100 text-red-700'
          : isLow
          ? 'bg-yellow-100 text-yellow-700'
          : 'bg-emerald-100 text-emerald-700'
      }`}
    >
      <Zap className="h-4 w-4" />
      <span>
        {data.remaining} / {data.dailyLimit} analyses remaining
      </span>
    </div>
  )
}

export default RateLimitBadge
